export const USER_APP_ROBOTS_PATH = '/user-app/robots';
export const USER_APP_MAPS_PATH = '/user-app/maps';
